var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardDinersclub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-card-dinersclub"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "card-dinersclub",
    clipPath: "url(#clip-card-dinersclub)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "diners-club",
    transform: "translate(-12.99 -4.912)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33638",
    "data-name": "Path 33638",
    d: "M21.6,21.331a5.321,5.321,0,0,0,3.454,5.031V16.3A5.321,5.321,0,0,0,21.6,21.331Z",
    transform: "translate(-1.345 -1.42)",
    fill: "#1e4b92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33639",
    "data-name": "Path 33639",
    d: "M31.3,16.3V26.363a5.4,5.4,0,0,0,3.454-5.031A5.321,5.321,0,0,0,31.3,16.3Z",
    transform: "translate(-3.761 -1.42)",
    fill: "#004a97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33640",
    "data-name": "Path 33640",
    d: "M27.564,24.943a5.4,5.4,0,0,0,3.454-5.031M30.042,10.6H25.687A9.159,9.159,0,0,0,16.3,19.987a9.311,9.311,0,0,0,9.387,9.237h4.355c5.106,0,9.762-4.13,9.762-9.237A9.61,9.61,0,0,0,30.042,10.6ZM25.687,28.4a8.523,8.523,0,1,1,8.561-8.486A8.59,8.59,0,0,1,25.687,28.4Z",
    transform: "translate(-0.025)",
    fill: "#1e4b92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33657",
    "data-name": "Path 33657",
    d: "M38.077,18.485a9.055,9.055,0,0,0-2.628-6.308A10.338,10.338,0,0,0,30.042,10.6H25.687A9.159,9.159,0,0,0,16.3,19.987a9.276,9.276,0,0,0,2.328,6.083,12.516,12.516,0,0,0,5.257,2.1,8.713,8.713,0,1,1,2.028.15h.375c6.458.075,11.79-4.355,11.79-9.837Z",
    transform: "translate(-0.025)",
    fill: "#1e4b92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33658",
    "data-name": "Path 33658",
    d: "M25.587,10.6A9.159,9.159,0,0,0,16.2,19.987a8.823,8.823,0,0,0,2.253,5.932l.225.225a13.243,13.243,0,0,0,5.182,2.1,8.713,8.713,0,1,1,2.028.15h.375a5.684,5.684,0,0,0,1.126-.075A9.99,9.99,0,0,0,34.6,16.758a10.442,10.442,0,0,0-3.379-6.083,5.684,5.684,0,0,0-1.126-.075H25.587Z",
    fill: "#1e4b92"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardDinersclub);
export default __webpack_public_path__ + "static/media/card-dinersclub.277702de6a33371cfb0312de2c7a199b.svg";
export { ForwardRef as ReactComponent };